class PISOfflineAudioController {
  constructor(stateService, CommonService, toasterService, userService, $uibModal) {
    'ngInject';
    this.stateService = stateService;
    this.CommonService = CommonService;
    this.toasterService = toasterService;
    this.userService = userService;
    this.$uibModal = $uibModal;
    const ctrl = this;
  }

  $onInit() {
    this.fetchOfflineSegments();
    this.editMode = false;
    this.hasEdit = this.userService.hasEditPIS();
  }

  fetchOfflineSegments() {
    this.stateService.getSegments().then(data => {
      this.segments = data.filter(x => x.offline === true && x.stream_type === 'AUDIO');
      for (let segment of this.segments) {
          if (segment.audio[0]) {
            segment.number = segment.audio[0].offline_number;
          }
      }
      this.segmentsText = data.filter(x => x.offline === true && x.stream_type === 'TEXT');
    });
  }

  onToggleEdit(event) {
    this.editMode = event.editMode;
    this.selection = event.item;
    this.textSegment = this.segmentsText.filter(x => x.number === event.item.number);
  }

  onFormSubmit(event) {
    this.editMode = event.mode;
    this.fetchOfflineSegments();
    this.selection = null;
  }

  onFileUpload(event) {
    this.stateService.getSegments().then(data => {
      this.segments = data;
      this.selection = this.segments.find(segment => segment.id === event.current.id);
    });
  }

  toggleEditor() {
    if (this.editMode) {
      this.editMode = false;
      this.fetchOfflineSegments();
      this.selection = null;
    } else {
      this.editMode = true;
    }
  }
}

angular
  .module('offline.module')
  .controller('PISOfflineAudioController', PISOfflineAudioController);